import React from "react";
import type { NotificationApi } from "../context/NotificationContext";

export const siteOnlyPathAllowed = (path: string) =>
  ["/site-builder", "/storage", "/storage/archive", "/settings", "/profile", "/support-requests"].includes(path)
  || /^\/support-response\/\d+$/.test(path);

export const showSiteOnlyNotice = (notify: NotificationApi) => notify.show({
  severity: "info", summary: "Тариф «Только сайт»", life: 5000,
  detail: <>Ваш тариф предусматривает работу только с сайтом. Хотите изменить его? <a href="/profile">Посмотреть тарифы</a></>,
});
